import KeenSlider from 'keen-slider';
import { BlockCustomHtml } from '@/javascripts/components/BlockCustomHtml';
import Mute from '@/javascripts/components/Mute';
import { initViewMode } from '@/javascripts/editor/init_view_mode';
import { bindCustomLinkPostEvent } from '@/javascripts/custom_link_menu';
import { mountReactComponents } from '@/utils/react_mount';
import { communityComponents } from '@/components/mountable/registry';
import { getCspNonce } from '@/utils/csp_nonce.util';

// requestInitPosts の dataType: 'script' は同一オリジンだと、jQueryが"text script"
// コンバーターでレスポンスをXHR取得した上でnonceなしのインラインscriptとしてeval
// するため、CSP enforce時にブロックされる。$.ajaxSetup({ scriptAttrs })でsrc付き
// <script>要素の生成経路に切り替える手も検証したが、その経路はXHRを使わないため
// request.xhr?がfalseになり、non_navigational_request?（application_controller.rb）
// に依存する既存ロジック（ログイン状態チェック等）を壊す（COMMUNITY-4268と同種の事故）。
// そのため、XHRでの取得はそのままに、evalする際だけnonceを渡すようconverterを上書きする。
const cspNonce = getCspNonce();
if (cspNonce) {
  $.ajaxSetup({
    converters: {
      'text script': (text: string) => {
        $.globalEval(text, { nonce: cspNonce });
        return text;
      },
    },
  });
}

const PageLayoutTop = {
  requestInitPosts: function (initPostUrl: string) {
    $.ajax({
      type: 'GET',
      url: initPostUrl,
      dataType: 'script',
    }).done(() => { });
  },
  initPostsByCallbackAndPostTagId: function (initPostUrl: string, postTagId: string) {
    if (window.IntersectionObserver) {
      const options = {
        root: null,
        rootMargin: '100px',
        threshold: 0,
      };

      const handleIntersect = (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.requestInitPosts(initPostUrl);
            observer.unobserve(entry.target);
          }
        });
      };

      const observer = new IntersectionObserver(handleIntersect, options);
      const target = document.querySelector(postTagId);
      if (target) {
        observer.observe(target);
      }
    } else {
      this.requestInitPosts(initPostUrl);
    }
  },
  bindCustomLinkPostEvent: function (doc: Document) {
    bindCustomLinkPostEvent(doc);
  },
};

if (!customElements.get('block-custom-html')) {
  customElements.define('block-custom-html', BlockCustomHtml);
}

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.PageLayoutTop = PageLayoutTop;
window.Coorum.KeenSlider = KeenSlider;
window.Coorum.Mute = Mute;
// AJAX で遅延ロードされたブロック内の React 島（SNS いいね等）をマウントするため公開。
// 基盤は load 時 1 回しか走査しないので、.js.erb から挿入後に呼ぶ。
window.Coorum.mountReactComponents = (root: HTMLElement) =>
  mountReactComponents(communityComponents, root);

$(() => {
  initViewMode();
});
